// @flow
import { path } from "ramda"
import errorMap from "./errorMap"
import type { GraphqlError } from "../types"
import { trackErrorData } from "./helpers"

const getErrorMessage = ({ graphQLErrors = [] }: GraphqlError) => {
  const error = graphQLErrors.find(x => {
    const code = path(["data", "code"], x)

    return code ? !!errorMap[code] : false
  })

  if (error) {
    trackErrorData(error)
    return errorMap[error.data.code]
  }

  return path(["0", "message"], graphQLErrors) || "Unknown error occured"
}

export default getErrorMessage



// WEBPACK FOOTER //
// ./src/common/graphql/getErrorMessage/index.js